var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Typography } from 'modules/v2/foundation/Typography';
import { StickyHeaderContainer, HeaderActions } from './styled';
export function ListHeader(props) {
    const { title, actions, children, sticky = false } = props, rest = __rest(props, ["title", "actions", "children", "sticky"]);
    return (<StickyHeaderContainer $sticky={sticky} alignItems="center" px="md" pt="md" gap="md" {...rest}>
      {title && (<Typography $fontSize="small" $appearance="100" $fontWeight="bold">
          {title}
        </Typography>)}
      {children}
      {actions && <HeaderActions>{actions}</HeaderActions>}
    </StickyHeaderContainer>);
}
